import { Icon, IconProps } from '@chakra-ui/react';
import { PenTool } from 'lucide-react';

export const PenToolIcon = (props: IconProps) => {
  return <Icon as={PenTool} height="24px" width="24px" {...props} />;
};
